import { api } from './api';
import ProcessDates from '@/resources/constants/process-dates';

export default {
  LoadAll () {
    const endpoint = encodeURI(
      ProcessDates.Endpoints.LoadAll());

    return api.get(endpoint);
  },

  NextProcessingSchedule () {
    const endpoint = encodeURI(
      ProcessDates.Endpoints.NextProcessingSchedule());

    return api.get(endpoint);
  },

  IsProcessing () {
    const endpoint = encodeURI(
      ProcessDates.Endpoints.IsProcessing());

    return api.get(endpoint);
  }
};
